<footer class="site_footer">
  <div class="conta_iner">
    <div class="main_footer uh_spc">
      <div class="single">
        <a href="/">
          <figure class="site_logo">
            <img [src]="assetsConst.coloredLogo" alt="Mega_Store" />
          </figure>
        </a>
        <p class="footer-description">
          {{ "footerDescription" | translate }}
        </p>
        <div class="social_icons">
          <!-- <h2>{{ "followUs" | translate }}</h2> -->
          <ul>
            <li (click)="openUrl('https://www.facebook.com/LibyanMega')">
              <a><img [src]="assetsConst.facebookIcon" alt="facebookIcon" /></a>
            </li>
            <li (click)="openUrl('https://www.instagram.com/libyanmega/')">
              <a>
                <img [src]="assetsConst.instagramIcon" alt="instagramIcon" />
              </a>
            </li>
            <li (click)="openUrl('https://x.com/LibyanMega')">
              <a><img [src]="assetsConst.twitterIcon" alt="twitterIcon" /></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="single">
        <h2>{{ "support" | translate }}</h2>
        <ul>
          <li routerLink="/cms/contactUs">
            <a>{{ "contactUs" | translate }}</a>
          </li>
          <li routerLink="/cms/faq">
            <a>{{ "faq" | translate }}</a>
          </li>
        </ul>
      </div>
      <div class="single">
        <h2>{{ "information" | translate }}</h2>
        <ul>
          <li>
            <a routerLink="/cms/aboutUs">{{ "aboutUs" | translate }}</a>
          </li>
          <li routerLink="/cms/termsAndConditionsUser">
            <a>{{ "termsConditions" | translate }}</a>
          </li>
          <li routerLink="/cms/privacyPolicyUserInfo">
            <a>{{ "privacyCookiesPolicy" | translate }}</a>
          </li>
        </ul>
      </div>
      <div class="single">
        <h2>{{ "shippingReturns" | translate }}</h2>
        <ul>
          <li routerLink="/cms/shippingAndDelivery">
            <a>{{ "shippingDelivery" | translate }}</a>
          </li>
          <li routerLink="/cms/returnsAndRefund">
            <a>{{ "onlineReturns" | translate }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="copyright">
      <p>{{ "AllRightsReserved" | translate }}</p>
    </div>
  </div>
</footer>

<footer class="mbl_ftr">
  <div class="conta_iner">
    <ul class="ftr_icon_lst">
      <li
        (click)="addClasstospecific('home')"
        [ngClass]="{
          active: router.url.includes('/home-v2') && !CatgySelected
        }"
        routerLink="/">
        <figure>
          <img src="{{ assetsConst.homeIcon }}" alt="img" />
        </figure>
        <figure class="active_icon">
          <img src="{{ assetsConst.fillHomeIcon }}" alt="img" />
        </figure>
        <span>{{ "home" | translate }}</span>
      </li>
      <!-- active: CatgySelected, -->
      <li
        (click)="addClasstospecific('categories')"
        [ngClass]="{
          active:
            CatgySelected &&
            !homeSelected &&
            !orderSelected &&
            !wishSelected &&
            !accountSelected
        }"
        routerLink="/categories">
        <figure>
          <img src="{{ assetsConst.catIcon }}" alt="img" />
        </figure>
        <figure class="active_icon">
          <img src="{{ assetsConst.fillCategoryIcon }}" alt="img" />
        </figure>
        <span>{{ "categories" | translate }}</span>
      </li>
      <li
        (click)="addClasstospecific('orders')"
        [ngClass]="{
          active: router.url.includes('/my-order/v2') && !CatgySelected
        }"
        routerLink="/my-order/v2">
        <figure>
          <img src="{{ assetsConst.orderIcon }}" alt="img" />
        </figure>
        <figure class="active_icon">
          <img src="{{ assetsConst.fillOrderIcon }}" alt="img" />
        </figure>
        <span>{{ "myOrders" | translate }}</span>
      </li>
      <li
        (click)="addClasstospecific('wishlist')"
        [ngClass]="{
          active: router.url.includes('/my-wishlist/v2') && !CatgySelected
        }"
        routerLink="/my-wishlist/v2">
        <figure>
          <img src="{{ assetsConst.heartIcon }}" alt="img" />
        </figure>
        <figure class="active_icon">
          <img src="{{ assetsConst.fillWishIcon }}" alt="img" />
        </figure>
        <span>{{ "wishlist" | translate }}</span>
      </li>
      <li
        (click)="addClasstospecific('account')"
        [ngClass]="{
          active: router.url.includes('/view-profile/profile') && !CatgySelected
        }"
        class="usr_ac">
        <figure (click)="LoginModal()">
          <img src="{{ assetsConst.userIcon }}" alt="img" />
        </figure>
        <figure class="active_icon" routerLink="/view-profile/profile">
          <img src="{{ assetsConst.fillUserIcon }}" alt="img" />
        </figure>

        <span (click)="LoginModal()">{{ "account" | translate }}</span>

        <!-- <span routerLink="/view-profile/profile" *ngIf="isSignedIn"
          >Account</span
        > -->
      </li>
    </ul>
  </div>
</footer>
